import { render, staticRenderFns } from "./ForCalcList.vue?vue&type=template&id=5b2c3d87&scoped=true"
import script from "./ForCalcList.vue?vue&type=script&lang=js"
export * from "./ForCalcList.vue?vue&type=script&lang=js"
import style0 from "./ForCalcList.vue?vue&type=style&index=0&id=5b2c3d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c3d87",
  null
  
)

export default component.exports